<script setup>
import { useQuasar } from 'quasar'
import { ref, toRefs } from 'vue'
import apiDashboard from '../../../api/dashboard.api'
import { useI18n } from "vue-i18n"
const { t } = useI18n()

const $q = useQuasar()

const props = defineProps({
  type: String,
  by: String,
  of: String
})

const { type, by, of } = toRefs(props)
const data = ref([])
const params = {
  type: by.value
}
const fetch = async () => {
  try {
    const res = await apiDashboard.getTop(`${type.value}/${of.value}`, params)

    data.value = res.data
  } catch (error) {
    console.log(error)
  }
}

fetch()
</script>

<template lang='pug'>
.top-container.q-pa-md(style="height: 35vh")
  q-card.cursor-pointer(
    bordered
    class="fit"
  )
    q-card-section
      .text-subtitle2.text-bold {{ t(`dashboard.top.${type}.${of}.${by}`) }}:
    q-card-section
      q-table(
        flat
        dense
        :no-data-label='t("table.nodata")'
        :loading-label='t("table.loading")'
        :rows='data'
        separator="cell"
        hide-bottom
        class="fit"
      )
</template>